import { render, staticRenderFns } from "./view-video.vue?vue&type=template&id=eb3a33e2&scoped=true"
import script from "./view-video.vue?vue&type=script&lang=js"
export * from "./view-video.vue?vue&type=script&lang=js"
import style0 from "./view-video.vue?vue&type=style&index=0&id=eb3a33e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3a33e2",
  null
  
)

export default component.exports